import { render, staticRenderFns } from "./CKycIPVDetails.vue?vue&type=template&id=a7f589bc&scoped=true&"
import script from "./CKycIPVDetails.vue?vue&type=script&lang=js&"
export * from "./CKycIPVDetails.vue?vue&type=script&lang=js&"
import style0 from "./CKycIPVDetails.vue?vue&type=style&index=0&id=a7f589bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f589bc",
  null
  
)

export default component.exports